import React from 'react';
import GlobalCard from '../GlobalCard/GlobalCard';
import LeaderBoardCardAppStudio from './LeaderBoard';
import { AppStudioTotalData } from './AppStudioTotalData';
import ReactAngularComponentCountGraph from './Graphs/ReactAngularComponentCountGraph';
import AppStudioGraphContainer from './AppStudioGraphContainer';
import ReactAngularRadarGraph from './Graphs/ReactAngularRadarGraph';
import ReactAngularComponentCountDoughnutGraph from './Graphs/ReactAngularComponentCountDoughnutGraph';
import ConsumerTable from '../LeaderBoard/ConsumerTable';


const AppStudio = () => {
  return (
    <div className='flex flex-col gap-[8px]'>
      <div className='flex flex-row gap-[8px] h-[60vh] '>
        <div className='flex flex-col w-[75%] gap-[8px]'>
          <GlobalCard
            data={AppStudioTotalData()}
            userTable={({ onClose }) => (
              <ConsumerTable title="Total Users" onClose={onClose} />
            )}
          />

          <div className='w-full h-full'>
            <AppStudioGraphContainer header="Click Count Of React and Angular in App Studio" Component={ReactAngularComponentCountGraph} className="" />
          </div>
        </div>
        <div className='w-[25%]'>
          <LeaderBoardCardAppStudio />
        </div>
      </div>
      <div className='flex flex-row gap-[8px] w-full  pb-[8px] '>
        <div className='w-[60%] rounded-lg shadow-custom'>
          <AppStudioGraphContainer header="App Studio Component Count Category Wise" Component={ReactAngularRadarGraph} className="" />
        </div>
        <div className='w-[40%] rounded-lg shadow-custom'>
          <AppStudioGraphContainer header="Count of Angular and React Count in App Studio" Component={ReactAngularComponentCountDoughnutGraph} className="" />
        </div>
      </div>
    </div>
  );
};

export default AppStudio;
